var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 748,
    viewBox: "0 0 854 748",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4415_19121)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4415_19121)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 427,
    cy: 374,
    r: 144,
    fill: "#FF8970",
    fillOpacity: 0.35
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4415_19121",
    x: -48.0345,
    y: -101.034,
    width: 950.069,
    height: 950.069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 165.517,
    result: "effect1_foregroundBlur_4415_19121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4415_19121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 748,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.206e53aedaeb5c992c2cb6b89d024f33.svg";
export { ForwardRef as ReactComponent };